import { render, staticRenderFns } from "./SingleRetailerEntry.vue?vue&type=template&id=1006390e&scoped=true&"
import script from "./SingleRetailerEntry.vue?vue&type=script&lang=ts&"
export * from "./SingleRetailerEntry.vue?vue&type=script&lang=ts&"
import style0 from "./SingleRetailerEntry.vue?vue&type=style&index=0&id=1006390e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1006390e",
  null
  
)

export default component.exports